import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { SumUpLogo } from '@sumup-oss/icons';
import { Anchor, Body } from '@sumup-oss/circuit-ui';

import { StyledComponentsParams } from 'types/components';

export const BottomLinksWrapper = styled.nav(
  ({ theme }: StyledComponentsParams) => css`
    margin-top: ${theme.spacings.giga};
  `,
);

export const BottomLinksList = styled.ul(
  ({ theme }: StyledComponentsParams) => css`
    list-style: none;
    ${theme.mq.kilo} {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
    }
  `,
);

export const Disclaimer = styled(Body)(
  ({ theme }: StyledComponentsParams) => css`
    margin-top: ${theme.spacings.tera};
    margin-bottom: ${theme.spacings.peta};
    text-align: left;
    ${theme.mq.mega} {
      text-align: center;
    }
  `,
);

export const FooterContainer = styled.footer(
  ({ theme }: StyledComponentsParams) => css`
    margin-top: calc(2 * ${theme.spacings.peta});
    width: 100%;
  `,
);

export const FooterLogo = styled(SumUpLogo)(
  ({ theme }: StyledComponentsParams) => css`
    height: calc(${theme.spacings.tera} + ${theme.spacings.bit});
    ${theme.mq.untilMega} {
      height: ${theme.spacings.tera};
    }
  `,
);

export const FooterWrapperTop = styled('div')(
  ({ theme }: StyledComponentsParams) => css`
    width: 100%;
    color: var(--cui-fg-subtle);
    background-color: var(--cui-bg-subtle);
    padding-top: ${theme.spacings.exa};
    padding-bottom: ${theme.spacings.tera};
  `,
);

export const FooterWrapperBottom = styled('div')(
  () => css`
    width: 100%;
    color: var(--cui-fg-subtle);
  `,
);

export const LogoLink = styled(Anchor)(
  () => css`
    width: fit-content;
    display: flex;
    color: var(--cui-bg-strong);
    &:visited,
    &:visited:active,
    &:visited:hover,
    &:hover,
    &:active,
    &:focus {
      color: var(--cui-bg-strong);
    }
  `,
);

export const LogoWrapper = styled.div(
  ({ theme }: StyledComponentsParams) => css`
    padding-bottom: ${theme.spacings.tera};
  `,
);

export const PrimaryLinksContainer = styled.nav(
  ({ theme }: StyledComponentsParams) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    ${theme.mq.kiloToMega} {
      margin-top: ${theme.spacings.tera};
    }
    ${theme.mq.untilKilo} {
      margin-bottom: ${theme.spacings.giga};
    }
  `,
);

export const PrimaryLinksItem = styled.li(
  ({ theme }: StyledComponentsParams) => css`
    color: var(--cui-fg-subtle);
    margin-bottom: ${theme.spacings.byte};

    a {
      border-radius: 0;
    }
  `,
);

export const PrimaryLinksList = styled.ul(
  ({ theme, colNumber }: StyledComponentsParams & { colNumber: number }) => css`
    width: 100%;
    list-style: none;
    ${theme.mq.kilo} {
      width: ${(100 / colNumber).toFixed(2)}%;
    }
  `,
);

export const SecondaryLinksItem = styled.li(
  ({ theme }: StyledComponentsParams) => css`
    ${theme.typography.body.two};
    margin-bottom: ${theme.spacings.byte};
    ${theme.mq.kilo} {
      display: inline;
      margin-right: ${theme.spacings.tera};
    }
    ${theme.mq.mega} {
      ${theme.typography.body.one};
    }

    a {
      padding: calc(${theme.spacings.bit} / 4) 0;
      border-radius: 0;
    }
  `,
);

export const SecondaryLinksList = styled.ul(
  () => css`
    list-style: none;
  `,
);

export const SocialLink = styled(Anchor)(
  ({ theme }: StyledComponentsParams) => css`
    color: var(--cui-fg-subtle);
    display: inline-block;
    margin-top: ${theme.spacings.kilo};
    margin-bottom: ${theme.spacings.kilo};
    margin-left: 0;
    margin-right: ${theme.spacings.mega};
    &:last-child {
      margin-right: 0;
    }
  `,
);

export const StyledAnchor = styled(Anchor)(
  ({ theme }: StyledComponentsParams) => css`
    color: var(--cui-fg-subtle);
    text-decoration: none;
    border-bottom: ${theme.borderWidth.kilo} solid;
    border-bottom-color: transparent;
    transition:
      color ${theme.transitions.default},
      border-bottom-color ${theme.transitions.default};
    &:hover,
    &:visited:hover,
    &:visited:active,
    &:visited:focus,
    &:focus,
    &:active {
      color: var(--cui-bg-accent-strong);
      border-bottom-color: var(--cui-bg-accent-strong);
    }
    &:visited {
      color: inherit;
    }
  `,
);
